export default __webpack_public_path__ + "static/fall15-45939e3fadc81e6c60b179674e46684b.webp";